import { render, staticRenderFns } from "./trial_status_widget.vue?vue&type=template&id=2b077e5a&"
import script from "./trial_status_widget.vue?vue&type=script&lang=js&"
export * from "./trial_status_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports